import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faRobot, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Modal } from 'react-bootstrap';
import './FloatingButtons.css';

function FloatingButtons() {
    const [showChat, setShowChat] = useState(false);
    const [messages, setMessages] = useState([]);
    const [inputMessage, setInputMessage] = useState('');
    const messagesEndRef = useRef(null);

    const API_KEY = "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";
    const API_URL = "https://api.openai.com/v1/chat/completions";

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    useEffect(() => {
        if (showChat) {
            // Send greeting when chat opens
            setMessages([{
                type: 'bot',
                text: 'Salut, cu ce vă pot asista?',
                timestamp: new Date()
            }]);
        }
    }, [showChat]);

    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const fetchAIResponse = async (message) => {
        try {
            const response = await fetch(API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${API_KEY}`,
                },
                body: JSON.stringify({
                    model: "gpt-3.5-turbo",
                    messages: [{ role: "user", content: message }],
                    max_tokens: 60,
                }),
            });

            const data = await response.json();
            if (data.choices && data.choices.length > 0) {
                return data.choices[0].message.content.trim();
            }
            return "Eroare: răspunsul nu este valid.";
        } catch (error) {
            console.error("Error:", error);
            return "Eroare: Nu am putut primi un răspuns de la AI.";
        }
    };

    const handleSendMessage = async (e) => {
        e.preventDefault();
        if (!inputMessage.trim()) return;

        // Add user message
        const userMessage = {
            type: 'user',
            text: inputMessage,
            timestamp: new Date()
        };
        setMessages(prev => [...prev, userMessage]);
        setInputMessage('');

        // Add loading message
        setMessages(prev => [...prev, { type: 'loading', text: '...' }]);

        // Get AI response
        const aiResponse = await fetchAIResponse(inputMessage);

        // Remove loading message and add AI response
        setMessages(prev => prev.filter(msg => msg.type !== 'loading'));
        setMessages(prev => [...prev, {
            type: 'bot',
            text: aiResponse,
            timestamp: new Date()
        }]);
    };

    const formatTimestamp = (date) => {
        return `${date.getHours()}:${String(date.getMinutes()).padStart(2, '0')}`;
    };

    return (
        <>
            <div className="floating-buttons">
                <a
                    href="tel:+40744626685"
                    className="floating-button phone-button"
                    title="Sunați-ne"
                >
                    <FontAwesomeIcon icon={faPhone} />
                </a>

                <a
                    href="https://wa.me/40744626685"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="floating-button whatsapp-button"
                    title="WhatsApp"
                >
                    <FontAwesomeIcon icon={faWhatsapp} />
                </a>

                <button
                    className="floating-button chatbot-button"
                    onClick={() => setShowChat(true)}
                    title="Chat cu noi"
                >
                    <FontAwesomeIcon icon={faRobot} />
                </button>
            </div>

            <Modal
                show={showChat}
                onHide={() => setShowChat(false)}
                className="chatbot-modal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FontAwesomeIcon
                            icon={faRobot}
                            className="bot-avatar"
                            style={{
                                color: '#66A5AD',
                                fontSize: '1.5rem'
                            }}
                        />
                        Chat cu Arges Expres
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="chat-body">
                    <div className="messages-container">
                        {messages.map((msg, index) => (
                            <div key={index} className={`message ${msg.type}`}>
                                {msg.type === 'bot' && (
                                    <figure className="avatar">
                                        <FontAwesomeIcon
                                            icon={faRobot}
                                            style={{
                                                color: '#66A5AD',
                                                fontSize: '1.5rem'
                                            }}
                                        />
                                    </figure>
                                )}
                                <div className="message-content">
                                    {msg.text}
                                    {msg.timestamp && (
                                        <div className="timestamp">
                                            {formatTimestamp(msg.timestamp)}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                        <div ref={messagesEndRef} />
                    </div>
                    <form onSubmit={handleSendMessage} className="chat-input-form">
                        <input
                            type="text"
                            value={inputMessage}
                            onChange={(e) => setInputMessage(e.target.value)}
                            placeholder="Scrieți un mesaj..."
                            className="chat-input"
                        />
                        <button type="submit" className="send-button">
                            <FontAwesomeIcon icon={faPaperPlane} />
                        </button>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default FloatingButtons;